import { ContextStore } from 'bernie-core';
import { Logger } from 'bernie-logger';

import { bffFetch, Headers } from './bff-fetch';

export class HotelOffersSource {
  private host: string;
  private logger: Logger;
  private forwardedHeaders: Headers;

  constructor(host = '', logger, forwardedHeaders: Headers = {}) {
    this.host = host;
    this.logger = logger;
    this.forwardedHeaders = forwardedHeaders;
  }

  public fetch(context: ContextStore, criteria: any, hotelId: number, travelAd: any) {
    const data = Object.assign({}, criteria);
    if (travelAd) {
      if (travelAd.testVersionOverride) {
        data.testVersionOverride = travelAd.testVersionOverride;
      }
      data.trackingData = travelAd.trackingData;
      data.rank = travelAd.rank;
      data.candidateHmGuid = travelAd.candidateHmGuid;
      data.beaconIssued = travelAd.beaconIssued;
      data.slots = travelAd.slots;
      data.position = travelAd.position;
      data.isLinkOff = travelAd.clickRedirectLinkoffTrackingUrl !== undefined;
    }

    return bffFetch(this.host, `hotel/${hotelId}/offers`, context, data, this.logger, this.forwardedHeaders);
  }
}
